import styled, { css } from 'styled-components'

import { themeColor, themeSpace } from '../theme'
import { Space } from '../Space'
import { Image } from '../Image'
import { Button } from '../Button'

export const StickyWrapper = styled.div<{ top: string }>`
  align-items: center;
  z-index: 100;
  position: fixed;
  top: ${({ top }) => top};
  right: 0px;
  min-height: 130px;
  height: auto;
  min-width: 40px;
  padding: ${themeSpace(1)};

  color: ${themeColor('darkGray')};
  background-color: ${themeColor('primary')};
  border-top-left-radius: 0.2em;
  border-bottom-left-radius: 0.2em;
  box-shadow: 0 4px 8px 0 rgba(255, 117, 0, 0.2);
`
export const Title = styled.h3`
  fill: currentColor;
  font-size: 18px;
  line-height: 1.5;
  font-weight: bold;
  text-align: center;
  margin: 0px;
  color: #003c7d;
`
export const TitleWrapper = styled(Space)`
  cursor: pointer;
  writing-mode: tb;
  color: ${themeColor('white')};
`
export const StyledImage = styled(Image)`
  transform: rotate(90deg);
  margin-right: 0px!;
  padding-bottom: ${themeSpace(1)};
`

export const ContactFormStickyWrapper = styled.div<{
  top: string
  bottomAndOverflow?: boolean
}>`
  align-items: center;
  z-index: 100;
  position: fixed;
  top: ${({ top }) => top};
  right: 50px;
  width: 310px;
  height: auto;
  min-width: 150px;
  padding: ${themeSpace(1)};

  ${({ bottomAndOverflow }) =>
    bottomAndOverflow
      ? css`
          bottom: 0px;
          overflow-y: auto;
        `
      : css``}

  color: ${themeColor('darkGray')};
  background-color: ${themeColor('white')};
  border-radius: 0.2em;
  border: 1px solid ${themeColor('gray')};
`
export const SubmitButton = styled(Button)`
  height: 40px;
  min-width: 80px;
  font-size: 16px;
`

export const UrlWrapper = styled.div`
  display: none;
`

export const ErrorMessage = styled.p`
  color: ${themeColor('danger')};
  font-weight: bold;
  align-self: center;
`
export const SuccessMessage = styled.p`
  color: ${themeColor('success')};
  font-weight: bold;
  text-align: center;
`
